import { apiJson } from "@/services/api";

/** Valores usados si el backend no responde (los mismos que trae la base de datos al instalarse). */
export const MAX_FILAS_EXCEL_DEFAULT = { banco: 300, gs1: 100 };

function limite(maxFilas) {
  return { maxFilas, UserId_Update: null, fecha_Update: null };
}

// banco: "Buscar por Excel" del Banco de Imágenes; gs1: "Procesar Excel con GS1".
const state = {
  busquedaExcel: {
    banco: limite(MAX_FILAS_EXCEL_DEFAULT.banco),
    gs1: limite(MAX_FILAS_EXCEL_DEFAULT.gs1),
    minimo: 1,
    maximo: 5000,
  },
};

const mutations = {
  setBusquedaExcel(state, config) {
    state.busquedaExcel = { ...state.busquedaExcel, ...config };
  },
};

const actions = {
  /** Máximo de filas de datos (sin encabezado) de cada carga por Excel. */
  async consultarBusquedaExcel({ commit }) {
    const res = await apiJson("GET", "/configuracion/busqueda-excel");
    commit("setBusquedaExcel", res.data);
    return res.data;
  },
  async guardarBusquedaExcel({ dispatch }, { tipo, maxFilas }) {
    try {
      await apiJson("PUT", `/configuracion/busqueda-excel/${tipo}`, { maxFilas });
    } catch (e) {
      throw { code: e.code || "Error PIMG-15", msg: e.msg || "No se pudo guardar la configuración. Inténtalo más tarde." };
    }
    return dispatch("consultarBusquedaExcel");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
